'use client';

import { Stack, Typography } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import { useMe } from '@prismo-io/feature-auth/providers/me';
import Link from 'next/link';
import type { FC } from 'react';
type Props = {
  url: string;
  userUrl: string;
  buttonName: string;
};
export const SectionFooter: FC<Props> = (props: Props) => {
  const {
    url,
    userUrl,
    buttonName
  } = props;
  const me = useMe();
  const isMe = me && me.url === userUrl;
  if (!isMe) return null;
  return <Stack width="100%" direction="row" spacing={2} justifyContent="center" component="footer" data-sentry-element="Stack" data-sentry-component="SectionFooter" data-sentry-source-file="index.tsx">
      <Button LinkComponent={Link} href={url} variant="text" color="inherit" sx={{
      p: 0,
      '& .MuiButton-startIcon': {
        display: 'none'
      }
    }} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        {buttonName}
      </Button>
    </Stack>;
};